import {dynamicApiCall} from "./dynamicApiCall";

export const organ_user_data = async () => {
  const option = {
    method: 'GET',
    endpoint: '/students-total-data/'
  }

  const response = await dynamicApiCall(option)

  if (response.status === 200) {
    return response
  } else {
    throw response
  }
};